import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdiantamentoRoutingModule } from './adiantamento-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AdiantamentoRoutingModule
  ]
})
export class AdiantamentoModule { }
